import axios from 'axios';

// Create axios instance with base URL from environment variable
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  verifyToken: () => api.get('/auth/me'),
  getCurrentUser: () => api.get('/auth/me'),
};

// Searches endpoints
export const searchesAPI = {
  list: (params) => api.get('/searches', { params }),
  create: (data) => api.post('/searches', data),
  update: (id, data) => api.patch(`/searches/${id}`, data),
  delete: (id) => api.delete(`/searches/${id}`),
  bulkDelete: (params) => api.delete('/searches/bulk', { params }),
  run: (id) => api.post(`/searches/${id}/run`),
  clear: (id) => api.post(`/searches/${id}/clear`),
  getResults: (id, params) => api.get(`/searches/${id}/results`, { params }),
  getRuns: (id) => api.get(`/searches/${id}/runs`),
  hideResults: (resultIds) => api.post('/searches/results/hide', { result_ids: resultIds }),
  downloadDoneGreenResultsCsv: () => api.get('/searches/download/done-green.csv', { responseType: 'blob' }),
};

// Users endpoints
export const usersAPI = {
  list: () => api.get('/users'),
};

// SP API endpoints
export const spapiAPI = {
  stats: () => api.get('/spapi/stats'),
};

export default api;
